import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AdminVendorListRequestDto, AdminVendorListResponseDto } from '../dto';

@Injectable()
export class OrganizationsApiService {
  private http = inject(HttpClient);

  private route = 'organizations';

  getAdminVendorList(
    data: AdminVendorListRequestDto = { isActive: true },
  ): Observable<AdminVendorListResponseDto[]> {
    return this.http.post<AdminVendorListResponseDto[]>(
      `admin/${this.route}/vendor-list`,
      data,
    );
  }
}
